<template>
    <div id="main" class="d-flex flex-column align-items-start justify-content-start mx-auto">
        <div class="px-2 py-4 w-100">
            <div class="row mx-0 w-100">
                <div class="col-5 px-0" id="img-outlet-container">
                    <div id="img-outlet">
                        <img :src="outlet_image" alt="Outlet Image">
                    </div>
                </div>
                <div class="col-7 pr-0 d-flex flex-column justify-content-center">
                    <div class="row mx-0">
                        <div class="col-12 px-0 d-flex justify-content-center">
                            <img id="hl-logo" src="https://dr4y4dqumhrhn.cloudfront.net/healthland_logo.png" alt="HealthLand Logo">
                        </div>
                    </div>
                    <div class="row mx-0 mt-4">
                        <div class="col-12 px-0 d-flex justify-content-center">
                            <img id="powered-by" src="https://dr4y4dqumhrhn.cloudfront.net/powered_by.png" alt="Powered By">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-4">
                <div class="col-12 px-0">
                    <div id="timer-outer-container">
                        <div id="timer-container" class="d-flex justify-content-center">
                            <img src="/assets/healthland/images/checkout-login/hourglass.png">
                            <div id="slot-held" class="ml-4 pt-1">SLOT HELD FOR : {{ format_minutes }} mins</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-4">
                <div class="col-12 px-0 text-center information-text">
                    Secure your booking instantly with WhatsApp. No password needed!
                </div>
                <div class="col-12 px-0 mt-2" id="login-div">
                    <a :href="`https://api.whatsapp.com/send?phone=60196266399&text=Hi%20HealthLand,%20I%20would%20like%20to%20Login%20with%20this%20WhatsApp%20number.%0A%0AOTP:%20${otp}`" target="_blank" @click="track_whatsapp_login_click">
                        <img src="/assets/healthland/images/checkout-login/login.png">
                    </a>
                </div>
            </div>
            <div class="row mx-0 w-100 my-6">
                <div class="col-12 px-0 text-center information-text">
                    ---&nbsp;OR&nbsp;---
                </div>
            </div>
            <div class="row mx-0 w-100">
                <div class="col-12 px-0 text-center information-text">
                    Button not working? Send this code to +60 19-626 6399
                </div>
            </div>
            <div class="row mx-2 w-100 mt-4">
                <div class="col-12 px-0 d-flex justify-content-center">
                    <div id="otp" class="pt-2">
                        OTP: {{otp}}
                    </div>
                    <div class="d-flex align-items-center" @click="copy_otp">
                        <img id="btn-copy" class="ml-4" src="/assets/healthland/images/checkout-login/copy.png">
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-8">
                <div class="col-12 px-0 text-center information-text">
                    Do not add extra text.
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: [],
    computed: {
        format_minutes() {
            const m = Math.floor(this.remaining_time / 60);
            const s = this.remaining_time % 60;
            return `${m}:${s.toString().padStart(2, '0')}`;
        },
    },
    data() {
        return {
            login_key: undefined,
            otp: undefined,
            remaining_time: 0,
            outlet_image: "",
            verification_completed: false,
        }
    },
    methods: {
        start_countdown() {
            this.timer = setInterval(() => {
                if (this.remaining_time > 0) {
                    this.remaining_time--;
                } else {
                    clearInterval(this.timer);
                    // Track verification timeout/failure
                    this.track_verification_timeout();
                    window.location.replace("/booking");
                }
            }, 1000);
        },
        get_booking_details() {
            const params = new URLSearchParams(window.location.search)
            const key = params.get("key")
            this.login_key = key;
            frappe.call({
                method: "healthland.www.checkout-login.index.get_booking_details",
                args: {
                    key: key,
                },
                callback: (r) => {
                    if (r.success) {
                        this.outlet_image = r.outlet_image;
                        this.otp = r.otp;
                        this.remaining_time = r.remaining_time;
                        if (this.remaining_time > 0) {
                            this.start_countdown();
                        }
                        else {
                            window.location.replace("/booking");
                        }
                    }
                    else {
                        window.location.replace("/booking");
                    }
                }
            })
        },
        copy_otp() {
            navigator.clipboard.writeText(this.otp);
        },
        track_whatsapp_login_click() {
            window.dataLayer.push({
                event: 'whatsapp_login_initiated',
                event_category: 'Checkout',
                event_label: 'User clicked WhatsApp login button',
                method: 'WhatsApp OTP',
                content_name: 'WhatsApp Login',
                content_category: 'Authentication',
                event_source: 'WhatsApp OTP Verification',
            });
        },
        track_verification_timeout() {
            window.dataLayer.push({
                event: 'whatsapp_verification_timeout',
                event_category: 'Authentication',
                event_label: 'Verification session expired',
                failure_reason: 'Session timeout',
                content_name: 'WhatsApp Verification Timeout',
                content_category: 'Authentication Failure',
                status: 'timeout',
                reason: 'Session expired before verification',
            });
        },
        async get_hashed_value(str) {
            if (!str) return undefined;

            const normalized = str.toLowerCase().trim();
            const encoder = new TextEncoder();
            const data = encoder.encode(normalized);
            const hashBuffer = await crypto.subtle.digest("SHA-256", data);

            return Array.from(new Uint8Array(hashBuffer))
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");
        }
    },
    mounted() {
        frappe.realtime.on("whatsapp_login", async (data) => {
            if (data.login_key === this.login_key) {
                this.verification_completed = true;

                const successPayload = {
                    event: 'whatsapp_verification_success',
                    event_category: 'Authentication',
                    event_label: 'WhatsApp OTP verified successfully',
                    method: 'WhatsApp OTP',
                    content_name: 'WhatsApp Verification',
                    status: 'success',
                    mobile_no: await this.get_hashed_value(data.mobile_no),
                    user_id: await this.get_hashed_value(data.user),
                };

                window.dataLayer.push(successPayload);

                window.location.replace(`/booking?sid=${data.sid}`);
            }
        });

        // Track page abandonment (user leaves before verifying)
        // Only track if they haven't verified yet
        window.addEventListener('beforeunload', () => {
            if (this.remaining_time > 0 && !this.verification_completed) {
                // Track page abandonment
                window.dataLayer.push({
                    event: 'whatsapp_verification_abandoned',
                    event_category: 'Authentication',
                    event_label: 'User left page before verification',
                    failure_reason: 'Page abandonment',
                    remaining_time: this.remaining_time,
                });
            }
        });

        this.verification_completed = false;
        this.get_booking_details();
    },
    beforeUnmount() {
        clearInterval(this.timer);
        frappe.realtime.off("whatsapp_login");
    }
}
</script>

<style scoped>
#main {
    width: 100vw;
    max-width: 380px;
}

#img-outlet-container {
    border: 3px solid #BB7927;
    border-radius: 15%;
}

#img-outlet {
    border: 8px solid #F7BA48;
    border-radius: 15%;
}

#img-outlet img {
    border: 3px solid #BB7927;
    border-radius: 12%;
}

#timer-outer-container {
    border: 3px solid #964F17;
    border-radius: 16px;
    padding: 6px;
    background-color: #BD753B;
}

#timer-container {
    border: 3px solid #592807;
    border-radius: 10px;
    padding: 3px 3px 3px 5px;
    background-color: #592807;
}

#timer-container img {
    width: 20px;
    height: auto;
}

#slot-held {
    font-family: "Minecraft", sans-serif;
    color: #F8DD98;
    font-size: 18px;
}

.information-text {
    font-family: "Minecraft", sans-serif;
    color: #271803;
    font-size: 20px;
}

#login-div img {
    width: 100%;
    height: auto;
}

#otp {
    width: 60%;
    font-family: "Minecraft", sans-serif;
    color: #FCF581;
    font-size: 30px;
    background-color: #271803;
    text-align: center;
    border-radius: 10px;
    border: 3px solid #FCF581;
    box-shadow: 0 0 5px #FCF581, 0 0 10px #FCF581;
}

#btn-copy {
    width: 30px;
    height: auto;
    cursor: pointer;
}
</style>